import React from 'react';
import { Settings } from 'lucide-react';
import QueueProcessingControl from '../components/Admin/QueueProcessingControl';

/**
 * Admin page for manual queue processing
 * Use this to process college data generation queue without waiting for cron
 */
const AdminQueue = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <Settings className="w-8 h-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-900">
              Queue Administration
            </h1>
          </div>
          <p className="text-gray-600">
            Manually trigger college data generation and monitor queue status
          </p>
        </div>

        {/* Queue Control */}
        <QueueProcessingControl />

        {/* Instructions */}
        <div className="mt-8 bg-blue-50 rounded-xl border border-blue-200 p-6">
          <h2 className="text-lg font-semibold text-blue-900 mb-3">
            How It Works
          </h2>
          <div className="space-y-2 text-sm text-blue-800">
            <p>
              <strong>1. Auto-Queue:</strong> When you add a college, 3 jobs are automatically queued (college_data, deadlines, essay_requirements)
            </p>
            <p>
              <strong>2. Manual Processing:</strong> Click "Process Queue Now" to trigger immediate processing of queued jobs
            </p>
            <p>
              <strong>3. AI Generation:</strong> Each job calls Claude to research and generate accurate college data
            </p>
            <p>
              <strong>4. Database Update:</strong> Results are saved to global_colleges for all users to benefit from
            </p>
          </div>
        </div>

        {/* Limitations Notice */}
        <div className="mt-4 bg-yellow-50 rounded-xl border border-yellow-200 p-4">
          <p className="text-sm text-yellow-800">
            <strong>Note:</strong> Vercel Hobby plan limits cron jobs to 2/day. Use this manual trigger for testing and development.
            Once on Pro plan, the queue will process automatically every 15 minutes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminQueue;
